import React from 'react';
import { navigate } from 'gatsby';
import browserLang from 'browser-lang';

import { LocaleProvider } from '@/context/LocaleContext';
import { defaultLang, getLanguages, urlPrefixPath } from './helpers';

const getLocaleForPage = (props: any) => {
  const { pageContext, path } = props;

  if (pageContext?.locale) {
    return pageContext.locale;
  }

  const splittedPath = path?.split('/') ?? [];

  // Prevent issue with applepay/conditions page redirect
  if (splittedPath.length < 3) {
    return undefined;
  }

  const locale = splittedPath[1];

  return getLanguages().includes(locale) ? locale : defaultLang;
};

export const wrapPageElement = ({ element, props }: any) => {
  if (typeof window !== 'undefined') {
    const detectedLanguage = browserLang({
      languages: getLanguages(),
      fallback: defaultLang,
    });

    if (!props?.pageContext?.locale && globalThis.window.location.href.includes('404')) {
      const prefix = urlPrefixPath ? `/${urlPrefixPath}` : '';
      navigate(`${prefix}/${detectedLanguage}`);
    }
  }

  const pageContext = {
    ...props.pageContext,
    locale: getLocaleForPage(props),
  };

  return (
    <LocaleProvider pageContext={pageContext}>
      {element}
    </LocaleProvider>
  );
};
